import React from 'react';
import PropTypes from 'prop-types';
import { values, result } from 'underscore';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { SummaryBarFactory } from './components';

export const AdSummaryBar = ({
  adGroup,
  i18n,
  scope,
  siteMap,
  summaryBarActivityLogger,
  permissions,
}) => {
  const {
    id,
    name,
    campaignType,
    campaignId,
    campaignName,
  } = adGroup;

  const queryParam = new QueryParam(scope.history.location, scope.history);
  const { adType } = queryParam.values;
  queryParam.remove(['adId']);
  if (adType) {
    queryParam.remove(['adType']);
  }

  const backButtonUrl = `/campaign/vnext/ads?${queryParam.stringify()}`;
  const adName = {
    Responsive: i18n.getString(_TL_('Responsive ad')),
    ResponsiveSearch: i18n.getString(_TL_('Responsive search ad')),
    DynamicSearch: i18n.getString(_TL_('Dynamic search ad')),
    DynamicResponsive: i18n.getString(_TL_('Responsive ad')),
  };

  const summaryBarProps = {
    backButtonProps: {
      url: backButtonUrl,
      buttonText: i18n.getString(_TL_('Back to ads')),
    },
    breadcrumbsProps: {
      campaignName,
      campaignId,
      // Fallback to 'All campaigns' if campaign type filter is not 'Search campaigns'
      campaignType: campaignType === CampaignType.Default ? campaignType : CampaignType.All,
      adGroupId: id,
      adGroupName: name,
      adName: adName[adType],
      maxDisplayedItems: 4,
    },
    i18n,
    summaryBarActivityLogger,
    scope,
    siteMap,
  };

  const isAppBarBreadcrumbEnabled = result(permissions.dynamic, 'AppBarBreadcrumb', false);
  return (<SummaryBarFactory {...summaryBarProps} hideBreadcrumb={isAppBarBreadcrumbEnabled} />);
};

AdSummaryBar.propTypes = {
  adGroup: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    campaignId: PropTypes.number.isRequired,
    campaignName: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    campaignType: PropTypes.oneOf(values(CampaignType)).isRequired,
    bid: PropTypes.number.isRequired,
    bidStrategy: PropTypes.string.isRequired,
    locations: PropTypes.array,
    audiences: PropTypes.array,
    devices: PropTypes.array,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: siteMapPropType.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  summaryBarActivityLogger: PropTypes.shape({
    changeScopeActivity: PropTypes.any,
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};
